import React from 'react'
import { useEffect, useState } from 'react';
// import './FaultSecondPageCustom_bus.css';
// import 
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_orion';
import NoData from '../../../Dashboard/Driveanalysis/NoData';
// import COmpBiDirTest from '../../Faultanalysis_Bus/orion_fault_analysis_second_page/FaultSecondPageChartsBidirRender_Bus';
import COmpBiDirTest_Orion from './FaultSecondPageChartsBidirRender_Orion';
import ChartLoader from '../../../Dashboard/Driveanalysis/ChartLoader';
import { duration } from 'moment';
import * as $ from "jquery";

export default function SecondPageSecondGraph_Orion(props) {

  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [defaultNav, setDefaultNav] = useState("BCS-1");
  const [dataMain, setDataMain] = useState([]);
  const [LineContainerBodyBD, setCssLineCont] = useState({ height: "300px" }); //width: "565px",
  // #ffa344 #358696
  const [topping, setTopping] = useState("Fault")

  const [toCalculateFault, setToCalculateFault] = useState(0)

  const [toCalculate, setToCalculate] = useState(0)

  const onRadioChange = e => {
    setDataMain([]); 
    setTopping(e.target.value)
    if (e.target.value === 'DTC') {
      setDefaultNav('CurrImb')
    }
  }

  function getNavTab(e, name) {
    setDefaultNav(name);
    if (name === 'SocImb') {
      $("#CurrImb").removeClass("active");
      $("#SocImb").addClass("active");
      setDefaultNav('SocImb')
      // responceDataSocImb(responceDataSocImbDataImb)
    }
    if(name === 'CurrImb'){
      $("#SocImb").removeClass("active");
      $("#CurrImb").addClass("active");
      setDefaultNav('CurrImb')
      // responceDataImb(responceDataImbDataImb)
    }
  }

  const responceDataFaultImbalance = (data) => {
    let dataArray = [];
    let maleAdd = 0;
    let femaleAdd = 0;
    data.forEach((obj1, index) => {
      maleAdd += obj1.duration;
      femaleAdd += obj1.occurance;
    })
    data.forEach((obj1, index) => {
      let male = (obj1.duration / maleAdd) * 100;
      let female = (obj1.occurance / femaleAdd) * 100;
      dataArray.push({ age: obj1.signal.toUpperCase(), male: -male, female: female, orgLevalMale: obj1.duration.toFixed(0).toString(), orgLevalFemale: obj1.occurance.toFixed(0).toString() })
    })

    for (let i = 0; i < dataArray.length; i++) {
      let count = 0;
      for (let j = i + 1; j < dataArray.length; j++) {
        if (dataArray[i].age === dataArray[j].age) {
          dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
          count = 1;
        }
      }
      if (count) {
        dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
      }
    }
    dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
    setDataMain(dataArray)
  }

  const responceDataImlanace = (data) => {
    let objArr = [];
    let item = data[0];

    if (item.occurance_A.value !== 0 && item.duration_A.value !== 0) {
      objArr.push({
        "signal": "PACK-A",
        "occurance": item.occurance_A.value,
        "duration": item.duration_A.value
      })
    }
    if (item.occurance_B.value !== 0 && item.duration_B.value !== 0) {
      objArr.push({
        "signal": "PACK-B",
        "occurance": item.occurance_B.value,
        "duration": item.duration_B.value
      })
    }
    if (item.occurance_C.value != 0 && item.duration_C.value != 0) {
      objArr.push({
        "signal": "PACK-C",
        "occurance": item.occurance_C.value,
        "duration": item.duration_C.value
      })
    }
    if (item.occurance_D.value != 0 && item.duration_D.value != 0) {
      objArr.push({
        "signal": "PACK-D",
        "occurance": item.occurance_D.value,
        "duration": item.duration_D.value
      })
    }
    responceDataFaultImbalance(objArr)
  }

  const responceDataSocFaultImbalance = (data) => {
    let dataArray = [];
    let maleAdd = 0;
    let femaleAdd = 0;
    data.forEach((obj1, index) => {
      maleAdd += obj1.duration;
      femaleAdd += obj1.occurance;
    })
    data.forEach((obj1, index) => {
      let male = (obj1.duration / maleAdd) * 100;
      let female = (obj1.occurance / femaleAdd) * 100;
      dataArray.push({ age: obj1.signal.toUpperCase(), male: -male, female: female, orgLevalMale: obj1.duration.toFixed(0).toString(), orgLevalFemale: obj1.occurance.toFixed(0).toString() })
    })

    for (let i = 0; i < dataArray.length; i++) {
      let count = 0;
      for (let j = i + 1; j < dataArray.length; j++) {
        if (dataArray[i].age === dataArray[j].age) {
          dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
          count = 1;
        }
      }
      if (count) {
        dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
      }
    }
    dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
    setDataMain(dataArray)
  }

  const responceDataSocImbalanace = (data) => {
    let objArr1 = [];
    let item = data[0];
    if (item.A_pack_soc_occ.value !== 0 && item.A_pack_soc_duration.value !== 0) {
      objArr1.push({
        "signal": "PACK-A",
        "occurance": item.A_pack_soc_occ.value,
        "duration": item.A_pack_soc_duration.value
      })
    }
    if (item.B_pack_soc_occ.value !== 0 && item.B_pack_soc_duration.value !== 0) {
      objArr1.push({
        "signal": "PACK-B",
        "occurance": item.B_pack_soc_occ.value,
        "duration": item.B_pack_soc_duration.value
      })
    }
    if (item.C_pack_soc_occ.value !== 0 && item.C_pack_soc_duration.value !== 0) {
      objArr1.push({
        "signal": "PACK-C",
        "occurance": item.C_pack_soc_occ.value,
        "duration": item.C_pack_soc_duration.value
      })
    }
    if (item.D_pack_soc_occ.value !== 0 && item.D_pack_soc_duration.value !== 0) {
      objArr1.push({
        "signal": "PACK-D",
        "occurance": item.D_pack_soc_occ.value,
        "duration": item.D_pack_soc_duration.value
      })
    }
    responceDataSocFaultImbalance(objArr1)
  }

  const responceDataFault = (data) => {
    let dataArray = [];
    let maleAdd = 0;
    let femaleAdd = 0;
    data.forEach((obj1, index) => {
      maleAdd += obj1.duration.value;
      femaleAdd += obj1.occurance.value;
    })
    data.forEach((obj1, index) => {
      let male = (obj1.duration.value / maleAdd) * 100;
      let female = (obj1.occurance.value / femaleAdd) * 100;
      dataArray.push({
        age: obj1.key.spnname.toUpperCase(), male: -male, female: female, orgLevalMale: obj1.duration.value.toFixed(0).toString(), orgLevalFemale: obj1.occurance.value.toFixed(0).toString(), signal_desc: obj1.key.Description, signal_val: obj1.key.spnvalue.toString()
      })
    })

    for (let i = 0; i < dataArray.length; i++) {
      let count = 0;
      for (let j = i + 1; j < dataArray.length; j++) {
        if (dataArray[i].age === dataArray[j].age) {
          // dataArray[j].age = dataArray[j].age + "_" + count;
          dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
          count = 1;
        }
      }
      if (count) {
        dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
      }
    }
    dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
    setDataMain(dataArray)
  }

  function addECU(dataArr, chngKey) {
    const mainECU = ["BCS-1", "BCS-2", "Aux-1", "Aux-2", "BMS", "MCU", "HVAC", "VCU"];;
    mainECU.forEach(element => {
      var index = dataArr.findIndex(x => x.key.ECU == element);
      index === -1 && dataArr.push({

        "key": { "ECU": element }, "doc_count": 0, [`${chngKey}`]: { "value": 0 }
      })
    });
    let dataA = dataArr.sort(function (a, b) {
      return a.key.ECU.localeCompare(b.key.ECU);
    });
    return dataA;
  }
  const responceBarData = (data) => {
    const ecu = addECU(data, "occurance")
    const foodBar = ecu.find(item => item.key.ECU === defaultNav);
    setToCalculateFault(foodBar.occurance.value);
  }

  const responceDataNew = (data) => {
    const objArray = [];
    Object.keys(data).forEach(key => objArray.push({
      name: key,
      rating: data[key]
    }))
    const mainECU = ["BCS", "BMS", "DCDC", "MCU", "OBC", "VCU"];
    mainECU.forEach(element => {
      var index = objArray.findIndex(x => x.name == element);
      index === -1 && objArray.push({
        "name": element, "rating": { "value": 0 }
      })
    });

    const objArrayA = objArray.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });

    const foodBar = objArrayA.find(item => item.name === defaultNav);
    setToCalculate(foodBar.rating.value);
  }


  const responceData = (data) => {
    let dataArray = [];
    let maleAdd = 0;
    (topping === "DTC") ? maleAdd = maleAdd : maleAdd = toCalculate;

    let femaleAdd = 0;
    data.forEach((obj1, index) => {
      if (topping === "DTC") {
        maleAdd += obj1.duration.value;
      }
      femaleAdd += obj1.occurance;
    })
    data.forEach((obj1, index) => {
      let male = (obj1.duration.value / maleAdd) * 100;
      let female = (obj1.occurance / femaleAdd) * 100;
      dataArray.push({ age: obj1.key.spnname.toUpperCase(), male: -male, female: female, orgLevalMale: obj1.duration.value.toFixed(0).toString(), orgLevalFemale: obj1.occurance.toFixed(0).toString(), signal_nm: obj1.key.spnname })
    })
    for (let i = 0; i < dataArray.length; i++) {
      let count = 0;
      for (let j = i + 1; j < dataArray.length; j++) {
        if (dataArray[i].age === dataArray[j].age) {
          dataArray[j].age = dataArray[j].age + "_" + dataArray[j].signal_val;
          count = 1;
        }
      }
      if (count) {
        dataArray[i].age = dataArray[i].age + "_" + dataArray[i].signal_val;
      }
    }
    dataArray.sort((a, b) => parseFloat(a.male) - parseFloat(b.male));
    setDataMain(dataArray)
  }

  useEffect(() => {
    if (topping === "Fault") {
      fetchData({ url: API_URL_MAIN + 'orion_fault_analysis_second_page/chartFault' + topping, body: { defaultNav: defaultNav, startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num, CITY: props.gloablfilter.CITY, DEPO: props.gloablfilter.DEPO, defaultNav: defaultNav, } }, responceDataFault);
    }
    if (topping === "Alarm") {
      fetchData({ url: API_URL_MAIN + 'orion_fault_analysis_second_page/chartAlarm' + topping, body: { defaultNav: defaultNav, startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num, CITY: props.gloablfilter.CITY, DEPO: props.gloablfilter.DEPO, defaultNav: defaultNav } }, responceDataFault);
    }
    if (topping === "DTC" && defaultNav === 'CurrImb') {
      fetchData({ url: API_URL_MAIN + 'orion_fault_analysis_second_page/chartImbalance' + topping, body: { defaultNav: defaultNav, startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num, CITY: props.gloablfilter.CITY, DEPO: props.gloablfilter.DEPO, defaultNav: defaultNav } }, responceDataImlanace);
    }
    if (topping === "DTC" && defaultNav === 'SocImb') {
      fetchData({ url: API_URL_MAIN + 'orion_fault_analysis_second_page/chartSocImbalance' + topping, body: { defaultNav: defaultNav, startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num, CITY: props.gloablfilter.CITY, DEPO: props.gloablfilter.DEPO, defaultNav: defaultNav } }, responceDataSocImbalanace);
    }

  }, [topping, defaultNav, props, toCalculate])



  return (
    <div className="col-md-12 col-lg-6 col-sm-12 mb-3">
      <div className="v-title chartbox3">
        <div className="row titlebg_bus_fault ">
          <div className="col-md-6 col-sm-6 col-lg-6">
            <div className="text-fit">Vehicle Level Fault/Alarm/Imbalance</div>
          </div>
          <div className="col-md-6 col-sm-6 col-lg-6 py-2" style={{ textAlign: 'end' }}>
            <div className="form-check form-check-inline bus">
              <input className="form-check-input" type="radio" name="inlineRadioOptions" id="Fault" value="Fault" checked={topping === "Fault"} onChange={onRadioChange} />
              <label className="form-check-label" htmlFor="inlineRadio1">Fault</label>
            </div>
            <div className="form-check form-check-inline bus">
              <input className="form-check-input" type="radio" name="inlineRadioOptions" id="Alarm" value="Alarm" checked={topping === "Alarm"} onChange={onRadioChange} />
              <label className="form-check-label" htmlFor="inlineRadio2">Alarm</label>
            </div>
            <div className="form-check form-check-inline bus">
              <input className="form-check-input" type="radio" name="inlineRadioOptions" id="DTC" value="DTC" checked={topping === "DTC"} onChange={onRadioChange} />
              <label className="form-check-label" htmlFor="inlineRadio2">Imbalance</label>
            </div>
          </div>
        </div>

        {(topping === "Fault") || (topping === "Alarm") ?

          <div className="chartHGT">
            <div className="mt-2 mb-2">
              <div className="mt-3">

                <ul className="nav nav-tabs" role="tablist" style={{ marginBottom: "5px" }}>
                  <li className="nav-item">
                    <a className="nav-link active" data-bs-toggle="tab" href="#BCS-1" onClick={(e) => getNavTab(e, "BCS-1")}>BCS-1</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#BCS-2" onClick={(e) => getNavTab(e, "BCS-2")}>BCS-2</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#Aux-1" onClick={(e) => getNavTab(e, "Aux-1")}>Aux-1</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#Aux-2" onClick={(e) => getNavTab(e, "Aux-2")}>Aux-2</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#BMS" onClick={(e) => getNavTab(e, "BMS")}>BMS</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#MCU" onClick={(e) => getNavTab(e, "MCU")}>MCU</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#HVAC" onClick={(e) => getNavTab(e, "HVAC")}>HVAC</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#VCU" onClick={(e) => getNavTab(e, "VCU")}>VCU</a>
                  </li>
                  {topping === "Fault" ? (
                    <li className="nav-item">
                      <a className="nav-link" data-bs-toggle="tab" href="#DC-DC" onClick={(e) => getNavTab(e, "DC-DC")}>DC-DC</a>
                    </li>
                  ) : (
                    <></>
                  )}
                  
                </ul>

                <div className="tab-content">
                  <div className='row' style={{ textAlign: 'right' }}>
                    <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                      <dt className="red_bus" ></dt>
                      <dd>Time Duration (mins)</dd>
                      <dt className="yellow_bus" style={{ marginLeft: "5px" }}></dt>
                      <dd>Occurrence</dd>
                    </dl>
                  </div>
                  <div id="BCS-1" className="tab-pane active"><br />
                    <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                      <div style={LineContainerBodyBD} >
                        {(isLoading) ? <ChartLoader /> :
                          (dataMain.length > 0 ?
                            <COmpBiDirTest_Orion dataMain={dataMain} id={"chartdivBCS-1"} /> :
                            <NoData />)
                        }
                      </div>
                    </div>
                  </div>
                  <div id="BCS-2" className="tab-pane "><br />
                    <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                      <div style={LineContainerBodyBD} >
                        {(isLoading) ? <ChartLoader /> :
                          (dataMain.length > 0 ?
                            <COmpBiDirTest_Orion dataMain={dataMain} id={"chartdivBCS-2"} /> :
                            <NoData />)
                        }
                      </div>
                    </div>
                  </div>
                  <div id="Aux-1" className="tab-pane"><br />
                    <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                      <div style={LineContainerBodyBD} >
                        {(isLoading) ? <ChartLoader /> :
                          (dataMain.length > 0 ?
                            <COmpBiDirTest_Orion dataMain={dataMain} id={"chartdivAux-1"} /> :
                            <NoData />)
                        }
                      </div>
                    </div>
                  </div>
                  <div id="Aux-2" className="tab-pane"><br />
                    <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                      <div style={LineContainerBodyBD} >
                        {(isLoading) ? <ChartLoader /> :
                          (dataMain.length > 0 ?
                            <COmpBiDirTest_Orion dataMain={dataMain} id={"chartdivAux-2"} /> :
                            <NoData />)
                        }
                      </div>
                    </div>
                  </div>
                  <div id="BMS" className="tab-pane"><br />
                    <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                      <div style={LineContainerBodyBD} >
                        {(isLoading) ? <ChartLoader /> :
                          (dataMain.length > 0 ?
                            <COmpBiDirTest_Orion dataMain={dataMain} id={"chartdivBMS"} /> :
                            <NoData />)
                        }
                      </div>
                    </div>
                  </div>
                  <div id="MCU" className="container tab-pane fade"><br />
                    <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                      <div style={LineContainerBodyBD} >
                        {(isLoading) ? <ChartLoader /> :
                          (dataMain.length > 0 ?
                            <COmpBiDirTest_Orion dataMain={dataMain} id={"chartdivMCU"} /> :
                            <NoData />)
                        }
                      </div>
                    </div>
                  </div>
                  <div id="HVAC" className="container tab-pane fade"><br />
                    <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                      <div style={LineContainerBodyBD} >
                        {(isLoading) ? <ChartLoader /> :
                          (dataMain.length > 0 ?
                            <COmpBiDirTest_Orion dataMain={dataMain} id={"chartdivHVAC"} /> :
                            <NoData />)
                        }
                      </div>
                    </div>
                  </div>
                  <div id="VCU" className="container tab-pane fade"><br />
                    <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                      <div style={LineContainerBodyBD} >
                        {(isLoading) ? <ChartLoader /> :
                          (dataMain.length > 0 ?
                            <COmpBiDirTest_Orion dataMain={dataMain} id={"chartdivVCU"} /> :
                            <NoData />)
                        }
                      </div>
                    </div>
                  </div>
                  <div id="DC-DC" className="container tab-pane fade"><br />
                    <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                      <div style={LineContainerBodyBD} >
                        {(isLoading) ? <ChartLoader /> :
                          (dataMain.length > 0 ?
                            <COmpBiDirTest_Orion dataMain={dataMain} id={"chartdivDC-DC"} /> :
                            <NoData />)
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> : <div>
          </div>}

        {(topping === "DTC") ?
          <div className="chartHGT">
            <div className="mt-2 mb-2">
              <div className="mt-3">

                <ul className="nav nav-tabs" role="tablist" style={{ marginBottom: "5px" }}>
                  <li className="nav-item">
                    <a className="nav-link active" data-bs-toggle="tab" href="#imbalance" id='CurrImb' onClick={(e) => getNavTab(e, "CurrImb")}>Curr. Imbalance</a>
                  </li>
                  <div style={{ paddingRight: "10px" }}></div>
                  <li className="nav-item">
                    <a className="nav-link " data-bs-toggle="tab" href="#imbalance" id='SocImb' onClick={(e) => getNavTab(e, "SocImb")}>Soc. Imbalance</a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div className='row' style={{ textAlign: 'right' }}>
                    <dl style={{ marginBottom: "0rem", paddingRight: "3rem" }}>
                      <dt className="red_bus" ></dt>
                      <dd>Time Duration (mins)</dd>
                      <dt className="yellow_bus" style={{ marginLeft: "5px" }}></dt>
                      <dd>Occurrence</dd>
                    </dl>
                  </div>
                  <div id="imbalance" className="tab-pane active"><br />
                    <div style={{ width: 'auto', maxWidth: 'auto', overflowX: 'scroll', overflowY: 'scroll' }}>
                      <div style={LineContainerBodyBD} >
                        {(isLoading) ? <ChartLoader /> :
                          (dataMain.length > 0 ?
                            <COmpBiDirTest_Orion dataMain={dataMain} id={"chartdivImb"} /> :
                            <NoData />)
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> : <></>
        }
      </div>
    </div>
  )
}
